import request from '@/utils/request';

// 组织管理 API（13 个端点）

// 组织列表
export function orgList(params) {
  return request({ url: '/api/admin/org/list', method: 'post', data: params });
}
// 组织详情
export function orgDetail(params) {
  return request({ url: '/api/admin/org/detail', method: 'post', data: params });
}
// 创建组织
export function orgCreate(params) {
  return request({ url: '/api/admin/org/create', method: 'post', data: params });
}
// 更新组织
export function orgUpdate(params) {
  return request({ url: '/api/admin/org/update', method: 'post', data: params });
}
// 停用/启用组织
export function orgDisable(params) {
  return request({ url: '/api/admin/org/disable', method: 'post', data: params });
}
// 组织管理员获取自己所属组织
export function orgMy(params) {
  return request({ url: '/api/admin/org/my-org', method: 'post', data: params || {} });
}

// 搜索平台用户（添加成员下拉选人）
export function orgUserSearch(params) {
  return request({ url: '/api/admin/org/user/search', method: 'post', data: params });
}

// ---- 成员管理 ----
export function orgMemberList(params) {
  return request({ url: '/api/admin/org/member/list', method: 'post', data: params });
}
export function orgMemberAdd(params) {
  return request({ url: '/api/admin/org/member/add', method: 'post', data: params });
}
export function orgMemberRemove(params) {
  return request({ url: '/api/admin/org/member/remove', method: 'post', data: params });
}
export function orgMemberChangeType(params) {
  return request({ url: '/api/admin/org/member/change-type', method: 'post', data: params });
}

// ---- 统计大屏 ----
export function orgStatsOverview(params) {
  return request({ url: '/api/admin/org/stats/overview', method: 'post', data: params });
}
export function orgStatsFamilies(params) {
  return request({ url: '/api/admin/org/stats/families', method: 'post', data: params });
}
export function orgStatsActive(params) {
  return request({ url: '/api/admin/org/stats/active', method: 'post', data: params });
}
export function orgStatsRevenue(params) {
  return request({ url: '/api/admin/org/stats/revenue', method: 'post', data: params });
}
export function orgStatsTrend(params) {
  return request({ url: '/api/admin/org/stats/trend', method: 'post', data: params });
}
